import { render, staticRenderFns } from "./HeaderMainMenuContainer.vue?vue&type=template&id=1be53e94&"
import script from "./HeaderMainMenuContainer.vue?vue&type=script&lang=js&"
export * from "./HeaderMainMenuContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports